import React from 'react'

const LogoutIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1251 9.75V11.445C16.1251 14.7975 14.7826 16.14 11.4301 16.14H11.3326C8.31762 16.14 6.93012 15.0525 6.68262 12.3975" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.67505 5.66969C6.90755 2.96969 8.29505 1.86719 11.3325 1.86719H11.43C14.7825 1.86719 16.125 3.20969 16.125 6.56219" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.2501 9H2.71509" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.3875 6.48438L1.875 8.99688L4.3875 11.5094" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    )
}

export default LogoutIcon






